import cx from 'clsx';
import { trackEvent } from '@kcd/event-tracker';

import Image, { AutoImageWrapper, getResizeImage } from '~/components/Image';
import { useLinkComponent } from '~/hooks/mobileApp';

type Props = {
  className?: string;
  eventName?: string;
  imageUrl: string;
  landingUrl?: string;
};
function EventBanner({ className, eventName, imageUrl, landingUrl }: Props) {
  const LinkComponent = useLinkComponent();

  const handleClick = () => {
    if (eventName) {
      trackEvent(eventName);
    }
  };

  return (
    <div className={cx(className)}>
      {landingUrl ? (
        <LinkComponent href={landingUrl}>
          <AutoImageWrapper>
            <Image
              layout="fill"
              src={getResizeImage({
                src: imageUrl,
                width: 640,
              })}
              alt="이벤트 배너"
              onClick={handleClick}
              loading="lazy"
            />
          </AutoImageWrapper>
        </LinkComponent>
      ) : (
        <AutoImageWrapper>
          <Image
            layout="fill"
            src={getResizeImage({
              src: imageUrl,
              width: 640,
            })}
            alt="이벤트 배너"
            onClick={handleClick}
            loading="lazy"
          />
        </AutoImageWrapper>
      )}
    </div>
  );
}

export default EventBanner;
